import { FC, useMemo } from "react";
import { SIDE } from "_constants";
import { ReactComponent as Ball } from "../assets/volleyball-ball.svg";
import { classNames } from "components/common/classNames";

export const ServiceAnimation: FC<{ side: SIDE; className?: string }> = ({
  side,
  className,
}) => {
  const baseAnchorClass = side === SIDE.AWAY ? "right-0" : "left-0";
  const containerSideClass =
    side === SIDE.AWAY ? "ml-auto mr-[2vw]" : "ml-[2vw] mr-auto";
  const translateDirection = side === SIDE.HOME ? 1 : -1;

  const translateAmounts = useMemo(
    () => ({
      ball2: `translate(${translateDirection * 1 * WIDTH}vw, -${
        1.5 * WIDTH
      }vw)`,
      ball3: `translate(${translateDirection * 3 * WIDTH}vw, -${
        2.2 * WIDTH
      }vw)`,
    }),
    [translateDirection]
  );

  return (
    <div
      className={classNames(
        "relative mb-[2vw] mt-0 flex-1",
        containerSideClass,
        className
      )}
    >
      <Ball
        className={classNames(
          "volleyball-service-ball absolute bottom-0 h-auto w-[5vw]",
          baseAnchorClass
        )}
      />
      <Ball
        className={classNames(
          "volleyball-service-ball volleyball-service-ball-2 absolute bottom-0 h-auto w-[5vw]",
          baseAnchorClass
        )}
        style={{ transform: translateAmounts.ball2 }}
      />
      <Ball
        className={classNames(
          "volleyball-service-ball volleyball-service-ball-3 absolute bottom-0 h-auto w-[5vw]",
          baseAnchorClass
        )}
        style={{ transform: translateAmounts.ball3 }}
      />
    </div>
  );
};

const WIDTH = 5;
